"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const Button_1 = require("@App/kit/components/Buttons/Button");
const ModalPortal_1 = __importDefault(require("@App/kit/components/Popups/ModalPortal"));
const Sidebar_1 = require("@App/kit/components/Sidebars/Sidebar");
const contexts_1 = require("@App/contexts");
const DownloadSidebar_1 = require("@Components/Sidebars/DownloadSidebar");
const sidebar_download_type_1 = require("@App/enum/sidebar-download-type");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const RoyaltiesStatementsFilter_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/RoyaltiesStatementsFilter"));
const RoyaltiesStatementsTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/RoyaltiesStatementsTable"));
const react_router_dom_1 = require("react-router-dom");
const RoyaltiesStatementsContentHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/RoyaltiesStatementsContentHeader"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const param_1 = require("@App/navigation/param");
const RightsholderRoyaltiesStatements = () => {
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const { statementsStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const setValuesFromParams = () => __awaiter(void 0, void 0, void 0, function* () {
        if (searchParams.has(param_1.SEARCH_PARAM.period)) {
            const searchPeriod = searchParams.get(param_1.SEARCH_PARAM.period);
            const usagePeriodOption = statementsStore.royaltiesUsagePeriodOptions.find((period) => period.label === searchPeriod);
            if (usagePeriodOption) {
                statementsStore.setUsagePeriod(usagePeriodOption);
            }
        }
        if (searchParams.has(param_1.SEARCH_PARAM.payee)) {
            const searchPayee = searchParams.get(param_1.SEARCH_PARAM.payee);
            const payeeOption = statementsStore.payeeOptionsForSelect.find((payeeOpt) => payeeOpt.value === searchPayee);
            if (payeeOption) {
                yield setPayeeAndLoadStatements(payeeOption, false);
            }
        }
    });
    const resetFilters = (resetPeriod) => {
        if (resetPeriod) {
            statementsStore.setUsagePeriod(statementsStore.royaltiesUsagePeriodOptions[0]);
        }
        statementsStore.setSelectedDsp(statementsStore.dspOptions[0]);
    };
    const setPayeeAndLoadStatements = (withThisPayee_1, ...args_1) => __awaiter(void 0, [withThisPayee_1, ...args_1], void 0, function* (withThisPayee, resetPeriod = true) {
        setLoading(true);
        statementsStore.setSelectedPayee(withThisPayee);
        statementsStore.resetDownloadData();
        yield statementsStore.loadStatements(withThisPayee.value);
        resetFilters(resetPeriod);
        setLoading(false);
    });
    (0, react_1.useEffect)(() => {
        preloaderStore.openMainPreloader(true);
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_royalties_statement');
        Promise.all([
            statementsStore.latestRoyaltiesDate ? Promise.resolve() : statementsStore.loadLatestRoyaltiesDate(),
            statementsStore.payeeOptions ? Promise.resolve() : statementsStore.loadPayeeOptions(),
        ])
            .then(() => __awaiter(void 0, void 0, void 0, function* () {
            yield setValuesFromParams();
            statementsStore.setSelectedDsp(statementsStore.dspOptions[0]);
        }))
            .finally(() => {
            preloaderStore.openMainPreloader(false);
        });
        return () => {
            statementsStore.clearStatements();
            statementsStore.clearFilters();
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Royalty Statements' }),
        react_1.default.createElement("div", { className: "royalties-wrapper" },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(ContentHeader_1.default, { title: 'Royalty Statements', descriptionElement: react_1.default.createElement(RoyaltiesStatementsContentHeader_1.default, null) }),
                react_1.default.createElement(RoyaltiesStatementsFilter_1.default, { setPayeeAndLoadStatements: setPayeeAndLoadStatements }),
                loading ? react_1.default.createElement(PointPreloader_1.default, null) : react_1.default.createElement(RoyaltiesStatementsTable_1.default, null),
                react_1.default.createElement("div", { className: 'download-button' },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: !statementsStore.selectedPayee || statementsStore.downloadData.length === 0, onClick: () => setSidebarIsOpen(true) }, "Continue to download")))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: () => setSidebarIsOpen(false) },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: () => setSidebarIsOpen(false) },
                react_1.default.createElement(DownloadSidebar_1.DownloadSidebar, { closeSidebar: () => setSidebarIsOpen(false), downloadData: statementsStore.downloadData, sidebarDownloadType: sidebar_download_type_1.SidebarDownloadType.RoyaltyStatements })))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderRoyaltiesStatements);
